import React, { useEffect, useState } from "react";
import "./MyBets.css";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { Form, Row, Col } from "react-bootstrap";
import { fetchAllData, getAllData, PageVisit } from "../../../Utility/API";
import { sportEndPoint } from "../../../constant/Environment";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import void2 from "../../../image/Void.png";
import dnp from "../../../image/dnp.png";
import { Helmet } from "react-helmet";
import settledbets from "./SettledBets";
import { isMobile } from "react-device-detect";
import PastBetCard from "./PastBets";
import Loader from "../../../components/Loader";
import SettledBets from "./SettledBets";

const MyBets = () => {
  const [teamData, setTeamData] = useState([]);
  const [isPending, setIsPending] = useState(true);
  const [isLoading, setIsLoadinig] = useState(false);
  const [activeTab, setActiveTab] = useState("open"); // 👈 NEW state to toggle tabs

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { auth } = state;

  useEffect(() => {
    if (auth?.user?.idUser) {
      fetchteams(auth?.user?.idUser);
    }
  }, [Object.keys(auth?.user).length > 0]);

  const fetchteams = async (userId) => {
    setIsLoadinig(true);
    try {
      let url = `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.MY_TEAMS}/${userId}`;
      const response = await fetchAllData(url);
      const data = await response.json();
      console.log("response", data);
      if (data.status === "success") {
        setTeamData(data.data);
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      setIsLoadinig(false);
    }
  };

  const gotoHome = () => {
    dispatch({
      type: Actions.TEST_CASE,
      data: false,
    });
    navigate("/");
  };

  useEffect(() => {
    PageVisit(state?.auth?.user?.idUser || "", "my-entries");
  }, []);

  return (
    <div>
      <Helmet>
        <title>BettDraft - My Entries</title>
        <meta name="description" content="Review and manage your BettDraft fantasy sports entries and results." />
      </Helmet>
      {isLoading && <Loader visible={isLoading} />}
      <div className="container bg-color bg-white">
        <div className={isMobile ? "inner-small-space-mobile2" : "inner-small-space"}>
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-center sticky-div2 bg-white">
                <div className="col-md-12 text-center mb-2">
                  <div className="d-flex justify-content-evenly gap-3" gap={4}>
                    {/* Open Bets Button */}
                    <button
                      type="submit"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("open")}}
                      style={{
                        padding: "14px",
                        width: isMobile ? "250px" : "400px",
                        backgroundColor: activeTab === "open" ? "#1976d2" : "#4caf50",
                      }}
                      className={`green-button btn btn-success btn pastbtn `}
                    >
                      Open Bets
                    </button>

                    <button
                      type="submit"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("settled")}}
                      style={{
                        padding: "14px",
                        width: isMobile ? "250px" : "400px",
                        backgroundColor: activeTab === "settled" ? "#1976d2" : "#4caf50",
                      }}
                      className={`green-button btn btn-success btn pastbtn`}
                    >
                      Settled Bets
                    </button>

                      {/* <button
                      type="submit"
                      style={{
                        padding: "14px",
                        width: isMobile ? "250px" : "400px",
                      }}
                      className="green-button btn btn-success btn pastbtn"
                    >
                      My Teams
                    </button> */}

                  </div>
                </div>
              </div>

              <div className="custom-height-scroll">
                <div className="row">
                  {/* Show Open Bets */}
                  {activeTab === "open" && (
                    <>
                      <PastBetCard teamData={teamData.filter(item => item.status == "Active")} />
                      {/* {isPending && teamData.length === 0 && (
                        <div className="col-md-12">
                          <div className="null-entries">
                            <p>No Entries placed yet !</p>
                            <button
                              className="btn-primary mt-2 btn save-btn placebetbtn"
                              onClick={gotoHome}
                            >
                              PLACE BET
                            </button>
                          </div>
                        </div>
                      )} */}
                    </>
                  )}

                  {/* Show Settled Bets */}
                  {activeTab === "settled" && (
                    <SettledBets teamData={teamData.filter(item => item.status == "Finished")} />
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyBets;
